module.exports = __webpack_public_path__ + "static/django-11-68f5c76bba3ee6a40d6c70ab99c96314.svg";